<script setup lang="ts">
import { PHeader, PLayout } from '@previo/design-system'
import { RouterView } from 'vue-router'
import { Color } from '@previo/codebooks'
import { onBeforeMount } from 'vue'
import { useFeatureFlags } from '@previo/feature-flags'
import AppMenuBar from '~/layouts/components/app-menu/AppMenuBar.vue'
import PageLoader from '~/layouts/components/PageLoader.vue'

onBeforeMount(async () => {
  await useFeatureFlags().waitForInit()
})
</script>

<template>
  <p-layout :color="Color.GREY_100">
    <p-header>
      <app-menu-bar />
    </p-header>

    <div>
      <router-view v-slot="{ Component }">
        <template v-if="Component">
          <suspense timeout="200">
            <component :is="Component" />

            <template #fallback>
              <page-loader />
            </template>
          </suspense>
        </template>
      </router-view>
    </div>
  </p-layout>
</template>
